import React, {Component} from 'react';
import './Page.css';
import pioneer from '../../img/pioneer.jpg';
import sundance from '../../img/sundance.jpg';
import './Modal.css';
import Pioneerg from './Pioneerg';
import Sundanceg from './Sundanceg';

class book extends Component {
    state = {
        classes: 'modal',
        page: 'Pioneerg',
        pages: {
            'Pioneerg': <Pioneerg/>,
            'Sundanceg': <Sundanceg/>
        }
    }

    modalHandler(n) {
        let tmp = '';

        if(n) {
            tmp = 'Sundanceg';
        } else {
            tmp = 'Pioneerg';
        }

        console.log(n);

        this.setState({
            classes: 'modal modal-shown',
            page: tmp
        });
    }

    closeModal() {
        this.setState({classes: 'modal'});
    }

    render() {
        return(
            <div className="page">
                <h1>Book an RV</h1>

                <div className={this.state.classes}>
                    <div className="modal__controls">
                        <button className="modal__button" onClick={() => {this.closeModal()}}>X</button>
                    </div>
                    {this.state.pages[this.state.page]}
                </div>

                <h2>2019 Heartland Pioneer BH175</h2>
                <img alt="ss1" src={pioneer} className="page__slide"/>
                <div className="page__slideshow-controls">
                    <button className="page__slideshow-button" onClick={() => {this.modalHandler(0)}}>View Info</button>
                </div>

                <h2>2017 Heartland Sundance</h2>
                <img alt="ss2" src={sundance} className="page__slide"/>
                <div className="page__slideshow-controls">
                    <button className="page__slideshow-button" onClick={() => {this.modalHandler(1)}}>View Info</button>
                </div>
            </div>
        )
    }
};

export default book;